// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__tn6ZO","content":"Loader_content__ogME-","iconWrapper":"Loader_iconWrapper__vtGyj","info":"Loader_info__hb1LB","row":"Loader_row__G6abn"};